export { FavoriteButton } from 'shared/components/favoriteButton/FavoriteButton';
